@if (environment.test) {
    <div class="test">
        Testomgeving
    </div>
}
<nav class="navbar navbar-expand-lg navbar-inverse bg-body-tertiary" data-bs-theme="dark">
    <div class="container-fluid">
        <a class="navbar-brand" routerLink="daily">CRM26</a>
        <button
            aria-expanded="false"
            aria-label="Toggle navigation"
            class="navbar-toggler"
            data-bs-target="#navbarToggler"
            data-bs-toggle="collapse"
            type="button">
            <span class="navbar-toggler-icon"></span>
        </button>
        <div class="d-flex gap-2 me-2">
            <div [class]="seireStatus().production" [routerLink]="seireStatus().production_url" class="curpoint"></div>
            <div [class]="seireStatus().health" [routerLink]="seireStatus().health_url" class="curpoint"></div>
            <div [class]="seireStatus().check" [routerLink]="seireStatus().check_url" class="curpoint"></div>
            <div [class]="seireStatus().acceptance" [routerLink]="seireStatus().acceptance_url" class="curpoint"></div>
        </div>
        <div class="navbar-collapse collapse" id="navbarToggler">
            <ul class="navbar-nav me-auto mb-2 mb-lg-0">
                @if (Functionalities.Daily | hasFunctionality : currentUser) {
                    <li class="nav-item"><a [routerLink]="Routenames.daily" class="nav-link">Daily</a></li>
                }
                @if (Functionalities.Weekly | hasFunctionality : currentUser) {
                    <li class="nav-item"><a [routerLink]="Routenames.weekly" class="nav-link">Weekly</a></li>
                }
                @if (Functionalities.HourRegistration | hasFunctionality : currentUser) {
                    <li class="nav-item"><a [routerLink]="Routenames.registration" class="nav-link">Urenregistratie</a></li>
                    <li class="nav-item d-flex align-items-center">
                        <a [routerLink]="Routenames.leave" class="nav-link">Verlof</a>
                        @if (LeaveService.unapprovedLeavesCount() > 0) {
                            <div [routerLink]="Routenames.leave" class="check-status-unapproved curpoint"></div>
                        }
                    </li>
                }
                <li class="nav-item"><a [routerLink]="Routenames.reports" class="nav-link">Rapportages</a></li>
                @if (Functionalities.PdfUnderlay | hasFunctionality : currentUser) {
                    <li class="nav-item"><a [routerLink]="[Routenames.pdf, Routenames.underlay]" class="nav-link">Briefpapier</a></li>
                }
                @if (Functionalities.Financials | hasFunctionality : currentUser) {
                    <li class="nav-item"><a [routerLink]="Routenames.financials" class="nav-link">Financials</a></li>
                }
                @if (!environment.production && !environment.test) {
                    <li class="nav-item"><a [routerLink]="Routenames.rightsMatrix" class="nav-link">Rechtenmatrix</a></li>
                }
            </ul>
            <ul class="navbar-nav d-flex">
                @if (Functionalities.Users | hasFunctionality : currentUser) {
                    <li class="nav-item"><a [routerLink]="Routenames.users" class="nav-link">Gebruikersbeheer</a></li>
                }
                @if (LocalStorage.user) {
                    <li class="nav-item"><a [routerLink]="Routenames.profile" class="nav-link">Profiel</a></li>
                    <li class="nav-item"><a [routerLink]="Routenames.logout" class="nav-link">Uitloggen</a></li>
                }
            </ul>
        </div>
    </div>
</nav>


<div class="container-fluid">
    <router-outlet></router-outlet>
</div>
